import { ChatWidgetCurrent } from "../../model/chat-wiget/types/ChatWigetCurrent.enum";
import { ChatWidgetAIForm } from "./ChatWidgetAIForm";

type ChatWidgetContentProps = {
  open: boolean;
  setOpen: ATVoidFunction<boolean>;
  current: ChatWidgetCurrent;
  setCurrent: ATVoidFunction<ChatWidgetCurrent>;
  buttonAnchor: { left: number; top: number } | null;
};

export const ChatWidgetContent: React.FC<ChatWidgetContentProps> = ({
  open,
  current,
  setCurrent,
  buttonAnchor,
}) => {
  if (!open || current === ChatWidgetCurrent.OTHER) {
    return null;
  }

  return (
    <ChatWidgetAIForm
      onBackAction={() => setCurrent(ChatWidgetCurrent.DEFAULT)}
      buttonAnchor={buttonAnchor}
    />
  );
};
